import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { logoutAction } from 'store/actions';
import { AgeRatingKey } from 'utils/ageRating';

export type Profile = {
  id: string;
  name: string;
  avatar?: string;
  isOwner: boolean;
  isKid: boolean;
  ageRating?: AgeRatingKey;
  userId?: string;
  wasAccountDeactivated?: boolean;
};

type ProfileState = {
  selectedProfileId: string | null;
  editingProfile: Profile | null;
};

const initialState: ProfileState = {
  selectedProfileId: null,
  editingProfile: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    startEditingProfile: (state, action: PayloadAction<Profile | null>) => {
      if (action.payload) {
        state.editingProfile = { ...action.payload };
      } else {
        state.editingProfile = {
          id: '',
          name: '',
          isOwner: false,
          isKid: false,
          ageRating: '18',
        };
      }
    },
    setEditingName: (state, action: PayloadAction<string>) => {
      if (state.editingProfile) {
        state.editingProfile.name = action.payload;
      }
    },
    setEditingAgeRating: (state, action: PayloadAction<AgeRatingKey>) => {
      if (state.editingProfile) {
        state.editingProfile.ageRating = action.payload;
      }
    },
    selectProfileId: (state, action: PayloadAction<string>) => {
      state.selectedProfileId = action.payload;
    },
    clearEditingProfile: (state) => {
      state.editingProfile = null;
    },
    clearSelectedProfileId: (state) => {
      state.selectedProfileId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => initialState);
  },
});

export const {
  startEditingProfile,
  setEditingName,
  setEditingAgeRating,
  selectProfileId,
  clearEditingProfile,
  clearSelectedProfileId,
} = profileSlice.actions;

export default profileSlice.reducer;
